import React, { useState } from 'react';
import { View, Text } from 'react-native'
import { DateTime } from 'luxon';

import {
  downloadReport,
  DownloadButton
} from 'app/src/elements/ReportDownload'

import { cardStyles as styles } from 'app/src/components/Reports';

const TxnJournal = () => {
  const [startOn, setStartOn] = useState(
    DateTime.now().minus({ months: 1 }).startOf('month').toISODate()
  );

  const [endOn, setEndOn] = useState(
    DateTime.now().minus({ months: 1 }).endOf('month').toISODate()
  );

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'txn-journal',
      params: { 'start-on': startOn, 'end-on': endOn }
    });
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Transaction Journal</Text>
      <Text style={styles.label}>Start On:</Text>
      <input
        style={styles.select}
        onChange={e => setStartOn(e.target.value)}
        value={startOn || ''}
        type="date"
      />
      <Text style={styles.label}>End On:</Text>
      <input
        style={styles.select}
        onChange={e => setEndOn(e.target.value)}
        value={endOn || ''}
        type="date"
      />
      <DownloadButton handleDownload={handleDownload} />
    </View>
  )
}

export default TxnJournal;
